/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveconscientiousnessright4Inputs */



/**
* | output |
* | --- |
* | "Planner" |
*
* @param {Personalitybigfiveconscientiousnessright4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveconscientiousnessright4 = /** @type {((inputs?: Personalitybigfiveconscientiousnessright4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveconscientiousnessright4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Planner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Planificador")
	return /** @type {LocalizedString} */ ("Планировщик")
});
export { personalitybigfiveconscientiousnessright4 as "personalityBigFiveConscientiousnessRight" }